import React from 'react';
import { Box } from '@mui/material';

const ACCENT_CLASSES = {
  blue: 'inline-style-5',
  red: 'inline-style-6',
  teal: 'inline-style-7',
  amber: 'inline-style-8',
  purple: 'inline-style-9',
};

const TREND_CLASSES = {
  up: 'up',
  down: 'down',
  flat: 'flat',
};

export default function KpiCards({ configs, className }) {
  if (!configs || configs.length === 0) return null;

  return (
    <Box className={`kpi-row ${className || ''}`} role="region" aria-label="Key Performance Indicators">
      {configs.map((config) => (
        <Box
          key={config.id}
          className={`kpi-card ${ACCENT_CLASSES[config.accent] || 'inline-style-5'} ${config.onClick ? 'inline-style-29' : ''}`}
          onClick={config.onClick}
          role={config.onClick ? 'button' : undefined}
          tabIndex={config.onClick ? 0 : undefined}
          onKeyDown={(e) => config.onClick && (e.key === 'Enter' || e.key === ' ') && config.onClick()}
        >
          <Box className="bar" />
          <p className="kpi-label">{config.label}</p>
          <p className="kpi-value">{config.value}</p>
          <div className={`kpi-sub ${TREND_CLASSES[config.trend?.type] || 'flat'}`}>
            {config.trend?.value}
          </div>
        </Box>
      ))}
    </Box>
  );
}
